// extracted by mini-css-extract-plugin
export default {"infoDescription":"movieInfo_infoDescription__+ZqNe","container":"movieInfo_container__jHHDI","ratingInfo":"movieInfo_ratingInfo__IUC3D"};